import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonUtilities } from 'src/assets/js/common-utilities';

@Component({
  selector: 'app-c-costing',
  templateUrl: './c-costing.component.html',
  styleUrls: ['./c-costing.component.css']
})
export class CCostingComponent implements OnInit {
  selectedtab: number = 0;
  displayBasic: boolean;
  GeneralRateList: any[]
  _State: any[]
  _OdaList: any
  _ContractType: any
  _FlatOdaList: any
  id: any
  typeid: any
  idflat:any
  HideOpenTYpe: boolean = true
  HideFlatTYpe: boolean = true
  HideArticleODA: boolean = true
  HideTonnageODA:boolean = true
  HideServiceable:boolean = true
  HideTranscationTYpe:boolean = true

  contacttypeid:any[]=[]
  HideGeneralRate: boolean = true
  HideArticleBased: boolean = true
  HideRegionLevel: boolean = true
  HideSlab: boolean = true
  Hide2DRate: boolean = true
  constructor(private utility: CommonUtilities, private router: Router) { }

  ngOnInit(): void {
    this.GeneralRateList = [{agentNo:'',agentName:" ",fatherName:"",mobileNo:""}];
    this.utility.pageLoadScript();
    this._OdaList = [
      { id: 1, name: 'Open Type ODA Charges' },
      { id: 2, name: 'Flat ODA Charges' },
      { id: 3, name: 'Non Servicable Location' },
      { id: 4, name: 'Case To Case ODA Charges' },
      { id: 5, name: 'Per Transacation ODA Charges' }
    ];
    this._FlatOdaList = [
      { idflat: 1, name: 'Article' },
      { idflat: 2, name: 'KG' },

    ];
    this._State = [
      {stateid:'1',statename:'TAMIL NADU'},
      {stateid:'2',statename:'Kerala'},
      {stateid:'3',statename:'Mumbai'},
      {stateid:'4',statename:'Delhi'},
    ];
    this._ContractType = [
      {contacttypeid:'1',contacttypename:'General' ,active:true},
      {contacttypeid:'2',contacttypename:'Article Based',active:true},
      {contacttypeid:'3',contacttypename:'Region Level',active:true},
      {contacttypeid:'4',contacttypename:'Slab',active:true},
      {contacttypeid:'5',contacttypename:'2D Rate',active:true},
    ]
  }
  goBack(event) {
    this.router.navigate(['/vCustomer']);
  }
  showBasicDialog() {
    this.displayBasic = true;
  }

  ChangeContractType(event){
     this.HideGeneralRate=true
    this.HideArticleBased=true
    this.HideRegionLevel=true
    this.HideSlab=true
    this.Hide2DRate=true
    var selectedid = event.value;
    for(var i=0;i<selectedid.length;i++){
      if (selectedid[i].contacttypeid == 1) {
        this.HideGeneralRate=false   
        }
        if (selectedid[i].contacttypeid == 2) {
          this.HideArticleBased=false
        }
        if (selectedid[i].contacttypeid == 3) {
          this.HideRegionLevel=false
        }
        if (selectedid[i].contacttypeid == 4) {
          this.HideSlab=false
        }
        if (selectedid[i].contacttypeid == 5) {
          this.Hide2DRate=false
        }        
    }   
  }
  /*ChangeContractType(event){
    var selectedid = event.value;
    // this.contacttypeid=[]
    // console.log("id",selectedid);
    // this._ContractType
    // for(var i=0;i<this._ContractType.length;i++){
    //   this.contacttypeid[i]=event.value[i].contacttypeid
    //   for(var j=0;j<event.value.length;j++)
    //   if(this.contacttypeid[j]==event.value[j].contacttypeid){

    //   }
    if (selectedid.contacttypeid == 1) {
    this.HideGeneralRate=false
    this.HideArticleBased=true
    this.HideRegionLevel
    this.HideSlab
    this.Hide2DRate
    }
    if (selectedid.contacttypeid == 2) {
      this.HideGeneralRate=true
      this.HideArticleBased=false
      this.HideRegionLevel=true
      this.HideSlab=true
      this.Hide2DRate=true
    }
    if (selectedid.contacttypeid == 3) {
      this.HideGeneralRate=true
      this.HideArticleBased=true
      this.HideRegionLevel=false
      this.HideSlab=true
      this.Hide2DRate=true
    }
    if (selectedid.contacttypeid == 4) {
      this.HideGeneralRate=true
      this.HideArticleBased=true
      this.HideRegionLevel=true
      this.HideSlab=false
      this.Hide2DRate=true
    }
    if (selectedid.contacttypeid == 5) {
      this.HideGeneralRate=true
      this.HideArticleBased=true
      this.HideRegionLevel=true
      this.HideSlab=true
      this.Hide2DRate=false
    }
    
  }*/
  ChangeODAMapping(event) {
    var selectedid = event.value;
    if (selectedid.id == 1) {

      this.HideOpenTYpe = false
      this.HideFlatTYpe = true
      this.HideServiceable = true
      this.HideTranscationTYpe = true

      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 2) {
      this.HideOpenTYpe = true
      this.HideFlatTYpe = false
      this.HideServiceable = true
      this.HideTranscationTYpe = true
    }
    if (selectedid.id == 3) {
      this.HideServiceable = false
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideTranscationTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 4) {
      this.HideServiceable = false
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideTranscationTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 5) {
      this.HideTranscationTYpe = false
      this.HideServiceable = true
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }

  }
  ChangeFlatODAMapping(event) {
    var selectedid = event.value;
    if (selectedid.idflat == 1) {
      this.HideArticleODA = false
      this.HideTonnageODA = true
    }
    if (selectedid.idflat == 2) {
      this.HideTonnageODA = false
      this.HideArticleODA = true
    }
  }
}

